module.exports = __webpack_public_path__ + "img/r1a-ur3.8198f38d.jpg";